import React from "react";
import { Title as NessieTitle, NessieThemeProvider } from "@classdojo/web";

export const Title = (props: any) => {
  return (
    <NessieThemeProvider>
      <NessieTitle {...props} />
    </NessieThemeProvider>
  );
};
